import script from "./SearchResultItems.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchResultItems.vue?vue&type=script&lang=ts&setup=true"

import "./SearchResultItems.vue?vue&type=style&index=0&id=7bb0f9dc&lang=less&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bb0f9dc"]])

export default __exports__